import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 32 32"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", { d: "M16.185 19.789c-2.019 0-4.025.544-5.834 1.632l-6.714 4.051 1.901 3.027 7.699-5.824 1.366-1.85h.216l-.271 11.156h3.261l-.27-11.155h.215l1.366 1.85 7.698 5.823 1.902-3.027-6.714-4.051a11.284 11.284 0 0 0-5.834-1.632h.013ZM23.07 15.546l-2.215-.308-.11-.198 9.384-5.331-1.63-2.95-9.114 5.823-.111-.198.85-2.157.978-9.875-3.459-.205v8.096c0 2.176.554 4.269 1.563 6.093a11.915 11.915 0 0 0 4.265 4.454l6.714 4.052 1.556-3.239-8.683-4.051.013-.006ZM13.163 14.323a12.563 12.563 0 0 0 1.563-6.093V.134L11.261.34l.979 9.875.85 2.157-.112.199-9.113-5.824-1.631 2.95 9.384 5.331-.11.199-2.216.307L.61 19.584l1.557 3.238 6.714-4.05a11.82 11.82 0 0 0 4.264-4.455h.013l.006.006Z" }, null, -1)
  ])))
}
export default { render: render }